<div class="kiene-content-page">
    <div *ngIf="isLoading" class="kiene-loading-spinner">
        <mat-spinner *ngIf="isLoading"></mat-spinner>
    </div>

    <div class="file-row">
        <h1
            >Bestellung <span *ngIf="bestellungExtern.bestell_nr">{{ bestellungExtern.bestell_nr }}</span></h1
        >
        <span class="kiene-spacer"></span>
        <div class="file-row">
            <button
                (click)="goBack()"
                mat-icon-button
                [matTooltip]="embeddedInDialog ? 'Schließen' : 'zurück'"
            >
                <mat-icon color="primary">{{ embeddedInDialog ? 'close' : 'arrow_back' }}</mat-icon>
            </button>

            <button
                (click)="saveBestellungExtern()"
                *kienePermission="[1763, 1082]"
                color="primary"
                mat-icon-button
                matTooltip="Zwischenspeichern"
            >
                <mat-icon>save</mat-icon>
            </button>
            <button
                (click)="downloadAlleDokumente()"
                *kienePermission="[1767, 1082]"
                [disabled]="bestellungExternId === 'neu'"
                color="primary"
                mat-icon-button
                matTooltip="Alle Dokumente als eine PDF herunterladen"
            >
                <mat-icon>cloud_download</mat-icon>
            </button>

            <div>
                <button
                    *kienePermission="[1742, 1752, 1082]"
                    [disabled]="bestellungExternId === 'neu'"
                    [matMenuTriggerFor]="befundOptionsMenu"
                    color="primary"
                    mat-icon-button
                    matTooltip="Dokumente hinzufügen"
                >
                    <mat-icon>cloud_upload</mat-icon>
                </button>
                <mat-menu #befundOptionsMenu>
                    <ng-template matMenuContent>
                        <button (click)="openAddDeliveryNoteDialog()" *kienePermission="[1742, 1082]" mat-menu-item>
                            <mat-icon>description</mat-icon>
                            <span>Lieferschein hinzuf&uuml;gen</span>
                        </button>
                        <button (click)="openAddInvoiceDialog()" *kienePermission="[1752, 1082]" mat-menu-item>
                            <mat-icon>description</mat-icon>
                            <span>Rechnung hinzuf&uuml;gen</span>
                        </button>
                    </ng-template>
                </mat-menu>
            </div>
            <div class="status-label">{{ bestellungExternId === "neu" ? "neu" : bestellungExtern.status }}</div>
        </div>
    </div>

    <div class="one-row">
        <span style="color: gray"
            >{{ supplier.bezeichnung }} , {{ supplier.strasse }} {{ supplier.plz }} {{ supplier.ort }}</span
        >
        <span class="kiene-spacer"></span>
        <span *ngIf="bestellungExtern.bestellt">bestellt am: {{ bestellungExtern?.bestellt | date: "medium" }}</span>
    </div>
    <div *ngIf="zeigtUntersuchungsauftrag()" class="one-row" style="margin-top: 8px; gap: 16px">
        <a
            [routerLink]="['/labor', 'untersuchungsauftrag', bestellungExtern.untersuchungsauftrag_id]"
            class="kiene-link"
            >Externer Untersuchungsauftrag {{ bestellungExtern.untersuchungsauftrag_id
            }}<ng-container *ngIf="bestellungExtern.tagebuch_nr_ua">
                · {{ bestellungExtern.tagebuch_nr_ua }}</ng-container
            ></a
        >
        <a
            *ngIf="bestellungExtern.befund_id_ua"
            [routerLink]="['/labor', 'befundmitteilungen', bestellungExtern.befund_id_ua]"
            class="kiene-link"
            >Befund {{ bestellungExtern.befund_id_ua }}</a
        >
    </div>

    <div *ngIf="deliveryNotes.length > 0">
        <h5>Lieferscheine</h5>
        <mat-chip-list>
            <mat-chip (removed)="openRemoveDokument(dn)" *ngFor="let dn of deliveryNotes" removable="true">
                <mat-icon>insert_drive_file</mat-icon>
                <span (click)="showDeliveryNotePdf(dn)" *kienePermission="[1741, 1082]" style="cursor: pointer">{{
                    dn.dateiname ? dn.dateiname : (dn.erstellt | date: "dd.MM.yyyy")
                }}</span>
                <mat-icon *kienePermission="[1744]" matChipRemove>cancel</mat-icon>
            </mat-chip>
        </mat-chip-list>
    </div>

    <div *kienePermission="[1751, 1082]">
        <div *ngIf="invoices.length > 0">
            <h5>Rechnungen</h5>
            <div class="file-row">
                <kiene-option-button
                    (onClick)="showInvoicePdf(iv)"
                    (optionClicked)="invoiceOption($event, iv)"
                    *ngFor="let iv of invoices"
                    [icon]="'insert_drive_file'"
                    [options]="[
                        { action: 'freigeben', text: 'freigeben', icon: 'check', permission: 1758 },
                        { action: 'gebucht', text: 'als gebucht markieren', icon: 'account_balance', permission: 1759 },
                        { action: 'loeschen', text: 'löschen', icon: 'delete', permission: 1754, permissions: [1754, 1082] }
                    ]"
                    [text]="iv.dateiname"
                ></kiene-option-button>
            </div>
        </div>
    </div>

    <div style="width: 100%">
        <h4>Positionen</h4>
        <mat-card>
            <div *ngIf="bestellungExtern?.positionen?.length > 0" style="width: 100%">
                <div class="flex-grid position">
                    <div class="pos-head">Pos.</div>
                    <div class="artikel-head">Artikel</div>
                    <div class="amount-head">Bestellmenge</div>
                    <div class="amount-head">Kommentar</div>
                    <div class="amount-head">Gelieferte Menge</div>
                    <div class="amount-head">Chargen</div>
                    <div class="remove-head"></div>
                </div>
            </div>
            <div *ngFor="let p of bestellungExtern?.positionen; let i = index" style="width: 100%">
                <div class="flex-grid position">
                    <div class="pos-col">{{ i + 1 }}.</div>
                    <div class="artikel-col">{{ positionsName(p) }}</div>
                    <div class="amount-col">
                        <mat-form-field *ngIf="editAllowed" class="menge-feld" appearance="outline">
                            <input matInput type="number" min="1" step="1" [(ngModel)]="p.menge_soll" />
                            <span matSuffix>{{ bestellEinheit(p) }}</span>
                        </mat-form-field>
                        <div *ngIf="!editAllowed">{{ bestellmengeText(p, p.menge_soll) }}</div>
                        <div *ngIf="packInfo(p)" class="mindest-info">{{ packInfo(p) }}</div>
                        <div *ngIf="packFehler(p)" class="mindest-hint">{{ packFehler(p) }}</div>
                        <div *ngIf="mindestbestellHinweis(p)" class="mindest-hint">{{ mindestbestellHinweis(p) }}</div>
                    </div>
                    <div class="amount-col">{{ p.kommentar }}</div>
                    <div class="amount-col">{{ bestellmengeText(p, p.menge_ist ? p.menge_ist : 0) }}</div>
                    <div class="amount-col">{{ p.chargen }}</div>
                    <div class="remove-col">
                        <button (click)="removePosition(p)" *ngIf="editAllowed" mat-icon-button>
                            <mat-icon>close</mat-icon>
                        </button>
                        <mat-icon *ngIf="p.menge_ist >= p.menge_soll" color="accent">check_circle</mat-icon>
                    </div>
                </div>
            </div>
        </mat-card>
        <div class="one-row">
            <div *kienePermission="[1766, 1082]">
                <button
                    (click)="markAsBooked()"
                    *ngIf="hasBestellungStatus(22)"
                    color="primary"
                    mat-stroked-button
                    style="margin-top: 20px"
                    >Als bestellt markieren
                </button>
            </div>
            <span class="spacer"></span>
            <div *kienePermission="[1766, 1082]">
                <button
                    (click)="order()"
                    *ngIf="hasBestellungStatus(22)"
                    color="primary"
                    mat-flat-button
                    style="margin-top: 20px"
                    >Bestellen
                </button>
            </div>
            <div *kienePermission="[1763, 1082]">
                <button
                    (click)="release()"
                    *ngIf="hasBestellungStatus(21)"
                    color="primary"
                    mat-flat-button
                    style="margin-top: 20px"
                    >Zur Bestellung freigeben
                </button>
            </div>
            <div *kienePermission="[1763, 1082]">
                <!-- 23 = bestellt, 24 = bestellt + mail, 25 = bestellt + fax, 27 = teilweise geliefert, 29 = als bestellt markiert -->
                <button
                    (click)="close()"
                    *ngIf="hasBestellungStatus(23, 24, 25, 27, 29)"
                    color="primary"
                    mat-flat-button
                    style="margin-top: 20px"
                    >Bestellung geliefert
                </button>
            </div>
        </div>
        <div style="width: 100%; text-align: right"> </div>
    </div>
</div>
